<template>  
  <v-layout wrap px-3 >
      <v-flex pr-2>
        <v-autocomplete multiple v-model="selectedFilterGliderIds" clearable clear-icon="mdi-close" item-text="key" item-value="id" :items="filterGliderList" :label="$t('Pilot.MissionDrawer.FilterGlider')" ref="ddlGlider" @click:append.stop="toggleDdlGlider()" :menu-props="{closeOnContentClick:true}"></v-autocomplete>
      </v-flex>
      <!--<v-flex sm6 pl-2> 
        <v-autocomplete multiple v-model="selectedMissionFleetIds" clearable clear-icon="mdi-close" item-text="key" item-value="id" :items="filteMissionFleetList" :label="$t('Pilot.MissionDrawer.FilterFleet')"></v-autocomplete>
      </v-flex>
      <v-flex sm6 pr-2>
        <v-autocomplete multiple v-model="selectedFilterAlarmIds" clearable clear-icon="mdi-close" item-text="key" item-value="id" :items="filterAlarmList" :label="$t('Pilot.MissionDrawer.FilterAlarm')"></v-autocomplete>
      </v-flex>-->
      <!--<v-flex sm6 pl-3 pt-1>
        <v-switch hide-details v-model="isOnGoingFiltered" :label="$t('Pilot.MissionDrawer.FilterOngoing')"></v-switch>
        <v-switch hide-details v-model="isSimulationFiltered" :label="$t('Pilot.MissionDrawer.FilterSimule')"></v-switch>
      </v-flex>-->
  </v-layout>
</template>
<script>
  import { mapGetters } from 'vuex'  
  export default {
   name: 'MissionFilter',       
   computed: {
       ...mapGetters([                  
         'missions',
         'filterMission',                        
         'allowedGliderFilterIds',
         'allowedMissionFleetFilterIds',
         'allowedAlarmFilterIds'
      ]),      
      selectedFilterGliderIds :{
          get() {
            return this.filterMission.gliderIds
          },
          set(newValue) {            
            this.$store.myActions.MISSION_SET_GLIDER_FILTER(newValue)
          }
      },
      selectedFilterAlarmIds :{
          get() {
            return this.filterMission.alarmIds
          },
          set(newValue) {            
            this.$store.myActions.MISSION_SET_ALARM_FILTER(newValue)
          }
      },
      isOnGoingFiltered:{
          get() {
            return this.filterMission.onGoing
          },
          set(newValue) {            
            this.$store.myActions.MISSION_SET_ONGOING_FILTER(newValue)
          }
      },
      isSimulationFiltered:{
          get() {
            return this.filterMission.simulated
          },
          set(newValue) {            
            this.$store.myActions.MISSION_SET_SIMULATED_FILTER(newValue)
          }
      },
      gliders() {
        return this.missions.map(m => { return  {id:m.gliId,key:m.gliKey}}).sort((a, b) => (a.key > b.key) ? 1 : -1)    
      },
      filterGliderList(){
        return this.gliders.filter(g => this.allowedGliderFilterIds[g.id])
      },
      filteMissionFleetList(){
        return [] //this.missionsFleet.filter(mf => this.allowedMissionFleetFilterIds[mf.id])
      },
      alarmsStatus(){
        return  Object.keys(this.$t('CodeAlarm')).map(k => {return {id:k,key:this.$t(`CodeAlarm.${k}`)}})        
      },
      filterAlarmList(){
        return this.alarmsStatus.filter(a => this.allowedAlarmFilterIds[a.id])
      }
    },
    mounted(){    
      //console.log("CodeAlarm",this.alarmsStatus)  
    },
    methods: {      
      toggleDdlGlider(){        
        if(!this.$refs.ddlGlider.isFocused) this.$refs.ddlGlider.onClick()
        else {
          this.$refs.ddlGlider.isFocused = false
          this.$refs.ddlGlider.isMenuActive = false
        }
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  
</style>
